import {
  TOGGLE_EDITOR,
  CLOSE_EDITOR,
  ACTIVATE_A_EDITOR,
  SET_EDITOR_TYPE,
} from '../actions/types';

const INITIALSTATE = {
  editorModalIsOpen: false,
  activeEditor: null,
  renderEditorsAsModal: false,
};

export default (state = INITIALSTATE, action) => {
  switch (action.type) {
    case TOGGLE_EDITOR:
      return { ...state, editorModalIsOpen: true };
    case CLOSE_EDITOR:
      return { ...state, editorModalIsOpen: false, activeEditor: null };
    case ACTIVATE_A_EDITOR:
      return { ...state, activeEditor: action.payload };
    case SET_EDITOR_TYPE:
      return {
        ...state,
        renderEditorsAsModal: action.payload,
      };
    default:
      return state;
  }
};
//tOGGEL ONLY OPENS
//CLOSE CLOSES AND DEACIVATES
// ACTIVATE ACTIVATES A MODEL



// WEBPACK FOOTER //
// ./src/redux/reducers/overviewEditor.js